import React, { useEffect, useState } from "react";
import {
  Container,
  Stack,
  Typography,
  Box,
  Paper,
  Divider,
  FormControl,
  TextField,
  Button,
  Grid,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import MuiButton from "../../components/muibutton";
import { useNavigate, useParams } from "react-router-dom";
import { getAPI, getAPIwithParams, postAPI } from "../../services/basehttpAPI";
import SnackbarComponent from "../../components/snackbar";
import MuiSingleSelectMenu from "../../components/muisingleselectmenu";
import * as BusinessConst from "../../utils/businessconstants";


const AddUser = () => {
  const { userid } = useParams();
  const navigate = useNavigate();
  const [selectedCustomersList, setSelectedCustomersList] = useState([]);
  const [customerData, setcustomerData] = useState([]);
  const [ShipToPartyData, setShipToPartyData] = useState([]);
  const [userShipToPartyList, setuserShipToPartyList] = useState([]);
  const [defaultUserShipToPartyList, setDefaultUserShipToPartyList] = useState([]);
  const [selectedUserShipToPartyList, setSelectedUserShipToPartyList] = useState([]);
  const [selectedUserShipToPartyDisplay, setselectedUserShipToPartyDisplay] = useState([]);
  const [defaultCustomersList, setDefaultCustomersList] = useState([]);
  const [formData, setFormData] = useState({});
  const [validfirstname, setvalidfirstname] = useState(null);
  const [validlastname, setvalidlastname] = useState(null);
  const [validemail, setvalidemail] = useState(null);
  const [validRegex, setValidRegex] = useState(true);
  const [errorfirstnametext, seterrorfirstnametext] = useState(null);
  const [errorlastnametext, seterrorlastnametext] = useState(null);
  const [erroremailtext, seterroremailtext] = useState(null);
  const [customerProfileList, setCustomerProfileList] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setmessage] = useState(null);
  const [severity, setseverity] = useState(null);
  const [existingCustomers, setExistingCustomers] = useState([]);
  const [userTypeList, setUserTypeList] = useState([]);
  const [errorusertypetext, seterrorusertypetext] = useState(null);
  const [validusertype, setvalidusertype] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [isAdmin, setIsAdmin] = useState(true);
  const [validCustomerProfile, setValidCustomerProfile] = useState(null);
  const [validShipToParty, setvalidShipToParty] = useState(null);
  const [errorcustomertext, seterrorcustomertext] = useState(null);
  const [errorshiptopartytext, seterrorshiptopartytext] = useState(null);
  const [currentUser, setCurrentUser] = useState({});
  const [IsAllSelected, setIsAllSelected] = useState(false);
  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));

  let navigationUrl = null;
  let pageName = null;

  if (userid) {
    pageName = translatedText?.edit_user//"Edit User";
    navigationUrl = `/layout/viewuser/${userid}`;
  } else {
    pageName = translatedText?.add_user //"Add User";
    navigationUrl = `/layout/users`;
  }

  useEffect(() => {
    getCurrentUserDetails();
    getAllUserTypes();
    getAllCustomerProfiles();
    getUserShipToPartyDetails();

    if (userid) {
      getExistingUserDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const isEmpty = (value) => {
    if (value === undefined || value === "" || value === null) {
      return true;
    } else {
      return false;
    }
  }

  const handleChange = (event) => {
    const { target } = event;
    setFormData((formData) => ({
      ...formData,
      [target.name]: target.value,
    }));
  };

  const handleUserRoleChange = (event) => {
    const value = event.target.value;
    handleChange(event);
    setSelectedUserType(value);
    if (value && value !== "") {
      setvalidusertype(false);
    }
    setSelectedCustomersList([]);
    setDefaultCustomersList([]);
    setDefaultUserShipToPartyList([]);
  };

  const handleCustomerChange = (values) => {
    setcustomerData([]);
    let data = [];
    values.forEach(x => {
      customerData.push(x.id);
    });
    let shipToPartyData = [...selectedUserShipToPartyDisplay];
    const validEntries = shipToPartyData.filter((x) => {
      return values.some(a => a.id === x.customerProfileId);
    });
    setselectedUserShipToPartyDisplay(validEntries);
    validEntries.forEach((y) => {
      data.push(y.id);
    })
    setSelectedUserShipToPartyList(data);
    setDefaultUserShipToPartyList([]);
    setSelectedCustomersList(customerData);
    if (values && values?.length > 0) {
      setValidCustomerProfile(false);
    }
  };

  const handleUserShipToPartyChange = (values) => {
    setShipToPartyData([]);
    const IsSelectAllPresent = values.some((x) => x.shipToId == "SelectAllShipToID")
    const OtherItems = values.filter((x) => x.shipToId != "SelectAllShipToID");
    if (IsSelectAllPresent && !IsAllSelected) {
      setIsAllSelected(true);
      let Shiptopartyitems = FetchShipToPartyList();
      Shiptopartyitems.forEach((x) => {
        ShipToPartyData.push(x.id)
      });
      OtherItems.forEach((x) => {
        ShipToPartyData.push(x.id)
      });
      setselectedUserShipToPartyDisplay([...OtherItems, ...Shiptopartyitems]);
      setSelectedUserShipToPartyList(ShipToPartyData);
    }
    else {
      setIsAllSelected(false);
      values.forEach((x) => {
        ShipToPartyData.push(x.id)
      });
      setselectedUserShipToPartyDisplay(values);
      setSelectedUserShipToPartyList(ShipToPartyData);
      const AllOptions = userShipToPartyList.filter((x) =>
        selectedCustomersList.some((z) => z === x.customerProfileId));
      if (AllOptions.length == OtherItems.length) {
        setIsAllSelected(true);
      }
    }
    if (values && values?.length > 0) {
      setvalidShipToParty(false);
    }
  };

  const getAllCustomerProfiles = async () => {
    let url = "CustomerProfile/GetAllCustomerProfile";
    const response = await getAPI(url, null);
    const profileList = response.responseData;
    transformCustomerProfileData(profileList);
  };

  const transformCustomerProfileData = (data) => {
    let newDataList = [];
    data?.map((obj) => {
      let newData = {
        id: obj.id,
        name: obj.customerName,
      };
      newDataList.push(newData);
      return newData;
    });
    setCustomerProfileList(newDataList);
  };

  const getAllUserTypes = async () => {
    let url = "ApplicationUser/GetApplicationRolesByKey";
    const roleModel = {
      lookupKey: "roles",
    };
    const response = await getAPIwithParams(url, roleModel);
    const userTypeList = response.responseData.lookups;
    transformUserTypeData(userTypeList);
  };

  const transformUserTypeData = (data) => {
    let newDataList = [];
    data?.map((obj) => {
      let newData = {
        id: obj.id,
        name: obj.lookupName,
        translationLabel: obj.translationLabel,
      };
      newDataList.push(newData);
      return newData;
    });
    setUserTypeList(newDataList);
  };

  const transformUserShipToPartyData = (data) => {
    let newDataList = [];
    let defaultShipToPartyList = [];
    let SelectedShipToPartyData = [];
    data?.map((obj, index) => {
      let newData = {
        id: index + "_" + (obj.customShipToPartyName || obj.shipToPartyName),
        usershipToPartyId: obj.id,
        name: (obj.customShipToPartyName || obj.shipToPartyName),
        applicationUserId: obj.applicationUserId,
        customerShiptoPartyId: obj.customerShiptoPartyId,
        shipToId: obj.shipToId,
        customerProfileId: obj.customerProfileId
      };
      newDataList.push(newData);
      if (obj.isSelected) {
        defaultShipToPartyList.push(newData);
        SelectedShipToPartyData.push(newData.id);
      }
      return newData;
    });
    setuserShipToPartyList(newDataList);
    setSelectedUserShipToPartyList(SelectedShipToPartyData);
    setDefaultUserShipToPartyList(defaultShipToPartyList);
    setselectedUserShipToPartyDisplay(defaultShipToPartyList);
  };

  const getExistingUserDetails = async () => {
    let url = "ApplicationUser/GetApplicationUserById";
    const userModel = {
      id: userid,
    };
    const response = await getAPIwithParams(url, userModel);
    const data = response.responseData;
    setFormData(data);
    setDefaultData(data);
    setSelectedUserType(data.lkRoleTypeId);
    setSelectedCustomersListData(data.userCustomerProfile);
  };

  const setSelectedCustomersListData = (data) => {
    let selectedCustomers = [];
    data?.map((customer) => {
      selectedCustomers.push(customer.customerProfileId)
    })
    setSelectedCustomersList(selectedCustomers);
  }


  const setDefaultData = (data) => {
    let defaultvalues = [];
    let usercustomers = [];
    data?.userCustomerProfile.map((obj) => {
      let DefaultData = {
        id: obj.customerProfileId,
        name: obj.customerName,
      };
      let cData = {
        id: obj.id,
        customerProfileId: obj.customerProfileId,
        name: obj.customerName,
      };
      defaultvalues.push(DefaultData);
      usercustomers.push(cData);
      return cData;
    });
    setDefaultCustomersList(defaultvalues);
    setExistingCustomers(usercustomers);
  };

  const getCurrentUserDetails = () => {
    let currentUserDetails = {
      marketId: 0,
      applicationLanguageId: 0,
    };
    if (sessionStorage.getItem("authToken")) {
      const decodeUserDetails = JSON.parse(
        window.atob(sessionStorage.getItem("authToken").split(".")[1])
      );
      currentUserDetails.marketId = decodeUserDetails.MarketId;
      currentUserDetails.applicationLanguageId =
        decodeUserDetails.ApplicationLanguageId;
    }
    setCurrentUser(currentUserDetails);
  };

  const getUserShipToPartyDetails = async () => {
    let url = "CustomerProfile/GetUserShipToPartyByUserId";
    const userModel = {
      userId: userid,
    };
    const response = await getAPIwithParams(url, userModel);
    const data = response;
    transformUserShipToPartyData(data);
  };

  useEffect(() => {
    seterrorfirstnametext(validfirstname ? translatedText.please_enter_firstname : null);
    seterrorlastnametext(validlastname ? translatedText.please_enter_lastname : null);
    seterroremailtext(validemail ? translatedText.please_enter_emailid : null);
    seterrorusertypetext(validusertype ? translatedText.please_select_user_role : null);
    seterrorcustomertext(
      validCustomerProfile ? translatedText.please_select_the_customers : null
    );
    seterrorshiptopartytext(
      validShipToParty ? "Please select Ship to party" : null
    );
    if (!validemail && !validRegex)
      seterroremailtext(!validRegex ? translatedText.invalid_email : null);
  }, [
    validRegex,
    validfirstname,
    validlastname,
    validemail,
    validusertype,
    validCustomerProfile,
    validShipToParty,
  ]);

  useEffect(() => {
    if (selectedUserType) {
      if (
        selectedUserType ===
        userTypeList.find(
          (n) => n.translationLabel === BusinessConst.admin_TranslationLabel
        )?.id
      ) {
        setIsAdmin(true);
      } else if (
        selectedUserType ===
        userTypeList.find(
          (n) => n.translationLabel === BusinessConst.endUser_TranslationLabel
        )?.id
      ) {
        setIsAdmin(false);
      }
    }

    // eslint-disable-next-line
  }, [selectedUserType]);

  function handleVaild(e) {
    if (e.target.value.trim() !== "") {
      if (e.target.name === "email") {
        const reg = new RegExp("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$");
        let isValidregex = reg.test(e.target.value);
        setValidRegex(isValidregex);
        setvalidemail(false);
      } else {
        setvalidfirstname(false);
        setvalidlastname(false);
        setvalidusertype(false);
        setValidCustomerProfile(false);
      }
    } else {
      if (e.target.name === "firstName") {
        setvalidfirstname(true);
      }
      if (e.target.name === "lastName") {
        setvalidlastname(true);
      }
      if (e.target.name === "email") {
        setvalidemail(true);
      }
      if (e.target.name === "userType") {
        setvalidusertype(true);
      }
      if (e.target.name === "userCustomerProfile") {
        setValidCustomerProfile(true);
      }
    }
  }

  const handleSubmitAndRedirect = async (e) => {
    e.preventDefault();
    let userCustomerProfile = [];
    let _userShipToPartyList = [];
    selectedCustomersList.map((custProfileId) => {
      const userCustId = existingCustomers.find(
        (e) => e.customerProfileId === custProfileId
      )?.id;
      let customerProfile = {
        id: userCustId === undefined ? 0 : userCustId, //if id = undefined then newly added customer
        customerProfileId: custProfileId,
        applicationUserId: userid ? formData.id : 0,
      };
      userCustomerProfile.push(customerProfile);
      return customerProfile;
    });
    formData.userCustomerProfile = userCustomerProfile;

    selectedUserShipToPartyList?.map((shipToParty) => {
      let selectedDetail = userShipToPartyList[shipToParty.split('_')[0]];
      let shipToPartyDetails = {
        id: selectedDetail.usershipToPartyId,
        applicationUserId: selectedDetail.applicationUserId,
        CustomerShiptoPartyId: selectedDetail.customerShiptoPartyId
      }
      _userShipToPartyList.push(shipToPartyDetails);
      return shipToPartyDetails;
    });
    formData._userShipToPartyList = _userShipToPartyList;

    if (
      !isEmpty(formData.firstName) &&
      !isEmpty(formData.lastName) &&
      !isEmpty(formData.email) &&
      !isEmpty(formData.lkRoleTypeId) &&
      (isAdmin || (!isAdmin && formData.userCustomerProfile?.length > 0 &&
      formData._userShipToPartyList?.length > 0))
    ) {
      if (
        !validfirstname &&
        !validlastname &&
        !validusertype &&
        !validemail &&
        !validCustomerProfile &&
        !validShipToParty &&
        validRegex
      ) {
        if (userid) {
          let url = "ApplicationUser/SaveApplicationUser";
          let user = {
            id: formData.id,
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            marketId: currentUser.marketId,
            applicationLanguageId: currentUser.applicationLanguageId,
            isLock: false,
            lkRoleTypeId: selectedUserType,
            userCustomerProfile: formData.userCustomerProfile,
            userShipToParty: _userShipToPartyList
          };
          const { data } = await postAPI(url, user);
          if (data !== null) {
            if (data.isSuccess) {
              setseverity("success");
              setmessage(translatedText.updated_sucessfully);
              navigate(navigationUrl);
            } else if (!data.isSuccess) {
              setseverity("error");
              setmessage(data.errorMessages);
            } else {
              setseverity("error");
              setmessage(translatedText.something_went_wrong_please_try_again_sometime);
              setOpen(true);
            }
          } else {
            setseverity("error");
            setmessage(translatedText.something_went_wrong_please_try_again_sometime);
            setOpen(true);
          }
        } else {
          let url = "ApplicationUser/SaveApplicationUser";
          let user = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            marketId: currentUser.marketId,
            applicationLanguageId: currentUser.applicationLanguageId,
            isLock: false,
            lkRoleTypeId: selectedUserType,
            userCustomerProfile: formData.userCustomerProfile,
            userShipToParty: _userShipToPartyList
          };
          const { data } = await postAPI(url, user);
          if (data !== null) {
            if (data.isSuccess) {
              setseverity("success");
              setmessage(translatedText.saved_sucessfully);
              navigate(navigationUrl);
            } else if (!data.isSuccess) {
              setseverity("error");
              setmessage(data.errorMessages);
            } else {
              setseverity("error");
              setmessage(translatedText.something_went_wrong_please_try_again_sometime);
              setOpen(true);
            }
          } else {
            setseverity("error");
            setmessage(translatedText.something_went_wrong_please_try_again_sometime);
            setOpen(true);
          }
        }
      } else {
        if (isEmpty(formData.firstName)) {
          setvalidfirstname(true);
        }
        if (isEmpty(formData.lastName)) {
          setvalidlastname(true);
        }
        if (isEmpty(formData.email)) {
          setvalidemail(true);
        }
        if (isEmpty(formData.lkRoleTypeId)) {
          setvalidusertype(true);
        }
        if (!isAdmin) {
          if (isEmpty(formData.customerProfileList)) {
            setValidCustomerProfile(true);
          }
          if (isEmpty(formData.userShipToPartyList)) {
            setvalidShipToParty(true);
          }
        }
      }
    } else {
      if (isEmpty(formData.firstName)) {
        setvalidfirstname(true);
      }
      if (isEmpty(formData.lastName)) {
        setvalidlastname(true);
      }
      if (isEmpty(formData.email)) {
        setvalidemail(true);
      }
      if (isEmpty(formData.lkRoleTypeId)) {
        setvalidusertype(true);
      }
      if (!isAdmin) {
        if (formData.userCustomerProfile?.length === 0) {
          setValidCustomerProfile(true);
        }
        if (formData._userShipToPartyList?.length === 0) {
          setvalidShipToParty(true);
        }
      }
    }
  };

  const handleNavigation = () => {
    navigate(-1);
  }

  const FetchCustomerList = () => {
    return customerProfileList.filter((x) => !selectedCustomersList.includes(x.id));
  }

  const FetchShipToPartyList = () => {
    return userShipToPartyList.filter((x) =>
      !selectedUserShipToPartyList.some((y) => y === x.id) &&
      selectedCustomersList.some((z) => z === x.customerProfileId));
  }

  const FilterAutoCompleteOptions = (options, { inputValue }) => {
    const OptionList = options.filter(item =>
      item.name.toLocaleLowerCase()
        .includes(inputValue.toLocaleLowerCase()) || item.shipToId.toLocaleLowerCase()
          .includes(inputValue.toLocaleLowerCase()));
    if (options.length != 0) {
      const SelectAllOption = {
        name: "Select All",
        shipToId: "SelectAllShipToID"
      };
      return [SelectAllOption, ...OptionList]
    }
    else {
      return [...OptionList]
    }
  }

  return (
    <Container maxWidth="lg" sx={{ mb: "50px" }}>
      <Typography variant="h5" flexGrow={1}>
        {pageName}
      </Typography>
      <Paper sx={{ width: "100%", height: "100%", mt: "20px" }}>
        <Box
          component="form"
          sx={{
            "& .MuiFormControl-root": {
              width: "90%",
            },
          }}
          autoComplete="off"
          noValidate
          onSubmit={(event) => handleSubmitAndRedirect(event)}>
          <Grid container>
            <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
              <FormControl>
                <TextField
                  margin="normal"
                  id="firstName"
                  name="firstName"
                  label={translatedText?.first_name}//"First Name"
                  value={formData.firstName || ""}
                  onChange={handleChange}
                  required
                  onBlur={handleVaild}
                  error={errorfirstnametext !== null ? true : false}
                  helperText={errorfirstnametext}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
              <FormControl>
                <TextField
                  margin="normal"
                  id="lastName"
                  name="lastName"
                  label={translatedText?.last_name}//"Last Name"
                  value={formData.lastName || ""}
                  onChange={handleChange}
                  required={true}
                  onBlur={handleVaild}
                  error={errorlastnametext !== null ? true : false}
                  helperText={errorlastnametext}></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
              <FormControl>
                <TextField
                  margin="normal"
                  id="email"
                  type="email"
                  name="email"
                  label={translatedText?.email_id}//"Email ID"
                  value={formData.email || ""}
                  onChange={handleChange}
                  required={true}
                  onBlur={handleVaild}
                  error={erroremailtext !== null ? true : false}
                  helperText={erroremailtext}></TextField>
              </FormControl>
            </Grid>
            <Grid item sm={6} sx={{ pl: "10px", pt: "15px" }}>
              <FormControl>
                <MuiSingleSelectMenu
                  id={translatedText?.user_role}//"User Role"
                  name="lkRoleTypeId"
                  defaultValue={formData.lkRoleTypeId}
                  options={userTypeList}
                  error={errorusertypetext !== null ? true : false}
                  helperText={errorusertypetext}
                  onChange={(event) => handleUserRoleChange(event)}
                  onErrorChange={(error) => seterrorusertypetext(error)}
                />
              </FormControl>
            </Grid>
            {selectedUserType ===
              userTypeList.find(
                (n) =>
                  n.translationLabel ===
                  BusinessConst.endUser_TranslationLabel
              )?.id && (
                <>
                  <Grid item xs={12} sm={12} md={12}>
                    <Divider />
                    <Typography variant="h6" flexGrow={1} m={2}>
                      {translatedText?.customer_access} {/*Customer Access*/}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
                    <Autocomplete
                      multiple
                      options={FetchCustomerList()}
                      getOptionLabel={(option) => option.name}
                      defaultValue={defaultCustomersList || []}
                      onChange={(e, values) => handleCustomerChange(values)}
                      renderInput={(data) => (
                        <TextField
                          {...data}
                          label="Select Customers"
                          variant="outlined"
                          error={errorcustomertext !== null ? true : false}
                          helperText={errorcustomertext}
                        />
                      )}
                    />
                  </Grid>


                  <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
                    <Autocomplete
                      multiple
                      options={FetchShipToPartyList()}
                      getOptionLabel={(option) => option.name}
                      defaultValue={defaultUserShipToPartyList || []}
                      onChange={(e, values) => handleUserShipToPartyChange(values)}
                      filterOptions={FilterAutoCompleteOptions}
                      value={selectedUserShipToPartyDisplay}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          <div>
                            {option.name}
                            {option.shipToId !== "SelectAllShipToID" && (
                              <>
                                <br />
                                <span style={{ fontSize: "12px", color: "gray" }}>{option.shipToId}</span>
                              </>
                            )}
                          </div>
                        </li>
                      )}
                      renderInput={(data) => (
                        <TextField
                          {...data}
                          label="Select Ship to party"
                          variant="outlined"
                          error={errorshiptopartytext !== null ? true : false}
                          helperText={errorshiptopartytext}
                        />
                      )}
                    />
                  </Grid>
                </>
              )}

            <Grid item xs={12}>
              <Stack
                direction="row"
                spacing={2}
                style={{ display: "flex", justifyContent: "flex-end" }}
                marginRight={"30px"}
                marginTop={"10px"}>
                <MuiButton
                  type="button"
                  text={translatedText?.cancel}//"Cancel"
                  color="grey"
                  onClick={handleNavigation}
                  show={true}
                />
                <Button type="submit" variant="contained" color="success">
                  {" "}
                  Save
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </Container>
  );
};
export default AddUser;
